import Vue from 'vue'
import Vuex from 'vuex'
import ConfigModule from './modules/configModule'
import vehicleTypeModule from './modules/vehicleTypeModule'
import ReportModule from '@/modules/reportModule'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// Vuex persist
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  filter: (mutation) => mutation.type !== 'setLoading'
})

export default new Vuex.Store<any>({
  modules: {
    config: ConfigModule,
    vehicleType: vehicleTypeModule,
    reportModule: ReportModule
  },
  state: {
  },
  mutations: {

  },
  actions: {

  },
  plugins: [vuexLocal.plugin]
})
